import { Route, Routes } from 'react-router-dom'
import { RotinasFrequentes } from '../pages/ADM/RotinasFrequentes'
import { ChamadosVendas } from '../pages/ADM/ChamadosVendas'
import { HistoricoChamados } from '../pages/ADM/HistoricoChamados'
import { Blog } from '../pages/ADM/Blog'
import { RelatorioChamados } from '../pages/ADM/RelatorioChamados'
import { CurriculosVendedores } from '../pages/ADM/CurriculosVendedores'
import { TextoSeoSite } from '../pages/ADM/TextoSeoSite'
import { PermissaoLiberacao } from '../pages/ADM/PermissaoLiberacao'
import { ControleUsuarios } from '../pages/ADM/ControleUsuarios'
import { HistoricoLiberacao } from '../pages/ADM/HistoricoLiberacao'
import { HistoricoLigacaoVendedor } from '../pages/ADM/HistoricoLigacaoVendedor'
import { PhotoManager } from '../pages/ADM/PhotoManager'
import { PhotoManagerLayout } from '../pages/ADM/PhotoManager/PhotoManagerLayout'
import { FotoPedidoStep } from '../pages/ADM/PhotoManager/steps/FotoPedidoStep'
import { FotoGaleriaStep } from '../pages/ADM/PhotoManager/steps/FotoGaleriaStep'
import { AnimatePresence } from 'framer-motion'
import { Artigos } from '../pages/ADM/Artigos'
import { Artigo } from '../pages/ADM/Artigos/Artigo'
import { InnovationResponde } from '../pages/ADM/InnovationResponde'
import { Cidades } from '../pages/ADM/Cidades'
import { RoletaDaSorte } from '../pages/ADM/RoletaDaSorte'
import AcompanhamentoApas from '../pages/ADM/AcompanhamentoApas'
import { AtualizacaoProdutosFornecedor } from '../pages/ADM/AtualizacaoProdutosFornecedor'
import { CadastroDeProdutoAPI } from '../pages/ADM/CadastroDeProdutoAPI'

export function RouteAdm() {
  return (
    <Routes>
      <Route path="/rotinas-frequentes" element={<RotinasFrequentes title="Rotinas Frequentes" />} />
      <Route path="/chamados-vendas" element={<ChamadosVendas />} />
      <Route path="/historico-chamados" element={<HistoricoChamados />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/relatorio-chamados" element={<RelatorioChamados />} />
      <Route path="/curriculo-vendedores" element={<CurriculosVendedores title="Currículo vendedores" />} />
      <Route path="/texto-seo-site" element={<TextoSeoSite />} />
      <Route path="/permissao-liberacao" element={<PermissaoLiberacao />} />
      <Route path="/controle-usuarios" element={<ControleUsuarios />} />
      <Route path="/historico-liberacao" element={<HistoricoLiberacao />} />
      <Route path="/historico-ligacao-vendedor" element={<HistoricoLigacaoVendedor />} />
      <Route path="/photo-manager" element={<PhotoManagerLayout />}>
        <Route index element={<PhotoManager />} />
        <Route
          path="fotos-para-pedido"
          element={
            <AnimatePresence>
              <FotoPedidoStep />
            </AnimatePresence>
          }
        />
        <Route path="fotos-para-galeria" element={<FotoGaleriaStep />} />
      </Route>

      <Route path="/artigos" element={<Artigos />} />
      <Route path="/artigos/:slug" element={<Artigo />} />
      <Route path="/artigos/:slug" element={<Artigo />} />

      <Route path="/responde/" element={<InnovationResponde.Root />} />
      <Route path="/responde/categoria/cadastro-pergunta" element={<InnovationResponde.Categoria />} />
      <Route path="/responde/produto/:id/cadastro-pergunta" element={<InnovationResponde.Produto />} />
      <Route path="/responde/home/cadastro-pergunta" element={<InnovationResponde.Home />} />
      <Route path="/responde/segmento/cadastro-pergunta" element={<InnovationResponde.Segmento />} />
      <Route path="/responde/ultra-rapido/cadastro-pergunta" element={<InnovationResponde.UltraRapido />} />

      <Route path="/cidades" element={<Cidades.Root />} />
      <Route path="/cidade/:slug" element={<Cidades.Cidade />} />
      <Route path="/roleta-da-sorte" element={<RoletaDaSorte />} />

      <Route path="/acompanhamento-apas" element={<AcompanhamentoApas />} />
      <Route path="/atualizacao-produtos-fornecedor" element={<AtualizacaoProdutosFornecedor />} />
      <Route path="/cadastro-de-produto-api" element={<CadastroDeProdutoAPI />} />
    </Routes>
  )
}
